// import { Astaric } from "../../HemeIconLibrary";
import React, { useEffect, useRef, useState } from "react"
import { Link } from "react-router-dom"
import Container from "react-bootstrap/Container"
import Nav from "react-bootstrap/Nav"
import Navbar from "react-bootstrap/Navbar"
import Modal from "react-bootstrap/Modal"
import hematogenix from "../../assets/images/Hematogenix.svg"
import NavDropdown from "react-bootstrap/NavDropdown"
import Profile from "../../assets/images/Profile.svg"
import NavIcon from "../../assets/images/nav-color.svg"
import {
  BuyIcon,
  Site,
  Study,
  Edit,
  Sponsor,
  Logout,
  ProfileIcon,
  CheckoutMenu,
  OrderHistory,
  SelectDownArrow,
  HeaderDropdownColor,
  AddressBook,
} from "../../HemeIconLibrary"
import { useSelector, useDispatch } from "react-redux"
import { setForm } from "../../Store/reducers/uiSettings"
import FormContainer from "../../components/Formik/formContainer"
import { NavLink, useNavigation } from "react-router-dom"
import Lottie from "lottie-react"
import * as animationData from "../../lotties/33493-star-celebration.json"
import { setCartAdded } from "../../Store/reducers/orders"
import { Button } from "../../utils"

const HemaNavbar = () => {
  const dispatch = useDispatch()
  const [CTA, setCTA] = useState()
  const [formName, setformName] = useState()
  const [formIcon, setFormIcon] = useState()
  const [formValidation, setFormValidation] = useState()
  const [updatedData, setUpdatedData] = useState()
  const [cancelText, setCancelText] = useState()
  const [CancelIcon, SetCancelIcon] = useState()
  const [confirmText, setConfirmText] = useState()
  const [CanfirmIcon, setCanfirmIcon] = useState()
  const [addtoCart, setAddToCart] = useState(false)
  const [openOrderM, setOpenOrderM] = useState(false)
  // Modal
  const popUpRef = useRef(null)
  const [show, setShow] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  const { user, orders, uisettings, cartAdded } = useSelector((state) => state)
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popUpRef.current && !popUpRef.current.contains(event.target)) {
        setOpenOrderM(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  const renderCartCount = () => {
    var cartItems = orders.allKitsforSite?.filter((kit) => !!kit.addtocart)
    var totalCount = 0
    if (cartItems && cartItems.length > 0) {
      totalCount = cartItems.reduce((a, b) => {
        return a + (b.count ? b.count : 1)
      }, 0)
    }

    return totalCount
  }

  useEffect(() => {
    if (orders.cartAdded) {
      setAddToCart(true)
      setTimeout(() => {
        setAddToCart(false)
      }, 3000)
      dispatch(setCartAdded(false))
    }
  }, [orders.cartAdded])

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  }

  return (
    <div className="h-[70px] hema-navbar fixed w-full top-0 left-0 z-[4] bg-primary1">
      <Navbar expand="lg" className="top-navbar-nav">
        <Container fluid className="navbar_container">
          <div className="flex w-full justify-between items-center pt-0 pb-0 pl-[24px] md:pl-[38px] pr-[24px] md:pr-[38px] lg:pr-0">
            <Navbar.Brand>
              <Link to="/">
                <img src={hematogenix} alt="" />
              </Link>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="navbarScroll" />
          </div>
          <Navbar.Collapse id="navbarScroll">
            <Nav className="my-2 me-auto my-lg-0 w-full " navbarScroll>
              <div className="w-full items-center gap-[20px] d-flex mobile_nav">
                {/* <div className=" w-fit px-4 py-[6px]  flex items-center justify-center gap-[10px]  rounded-full bg-primary2  ">
                  <div className="flex items-center gap-[2px] ">
                    <Sponsor />
                    <span className="text-gray font-semibold text-[14px] leading-[17px] mr-[5px]">
                      Sponsor:
                    </span>
                    <p className="m-0 text-sm font-normal text-white ">
                      {user.activeSponser?.name ||
                        localStorage.getItem('portal-active-sponsor')}
                    </p>
                  </div>
                  {user.userStatus?.sponsors.length > 1 && (
                    <div
                      className=""
                      onClick={() => {
                        dispatch(
                          setForm({ state: true, type: 'edit-user-status' })
                        );
                      }}
                    >
                      <Edit color="#ffffff" />
                    </div>
                  )}
                </div>
                <div className=" w-fit px-4 py-[6px]  flex items-center justify-center gap-[10px]  rounded-full bg-primary2  ">
                  <div className="flex items-center gap-[2px] ">
                    <Study color="#C0BEFF" />
                    <span className="text-gray font-semibold text-[14px] leading-[17px] mr-[5px]">
                      Study:
                    </span>
                    <p className="m-0 text-sm font-semibold text-white ">
                      {user.activeStudy?.name ||
                        localStorage.getItem('portal-active-study')}
                    </p>
                  </div>
                  {}
                  {user.userStatus?.studies.length > 1 && (
                    <div
                      className="cursor-pointer"
                      onClick={() => {
                        dispatch(
                          setForm({ state: true, type: 'edit-user-status' })
                        );
                      }}
                    >
                      <Edit color="#ffffff" />
                    </div>
                  )}
                </div>
                <div className=" w-fit px-4 py-[6px]  flex items-center justify-center gap-[10px]  rounded-full bg-primary2  ">
                  <div className="flex items-center gap-[2px] ">
                    <Site color="#C0BEFF" />
                    <span className="text-gray font-semibold text-[14px] leading-[17px] mr-[5px]">
                      Site:
                    </span>
                    <p className="m-0 text-sm font-semibold text-white ">
                      {user.activeSite?.name ||
                        localStorage.getItem('portal-active-site')}
                    </p>
                  </div>
                  {user.userStatus?.sites.length > 1 && (
                    <div
                      className="cursor-pointer"
                      onClick={() => {
                        dispatch(
                          setForm({ state: true, type: 'edit-user-status' })
                        );
                      }}
                    >
                      <Edit color="#ffffff" />
                    </div>
                  )}
                </div>
                <div className=" w-fit px-4 py-[6px]  flex items-center justify-center gap-[10px]  rounded-full bg-primary2  ">
                  <div className="flex items-center gap-[2px] ">
                    <Sponsor />
                    <span className="text-gray font-semibold text-[14px] leading-[17px] mr-[5px]">
                      PI:
                    </span>
                    <p className="m-0 text-sm font-semibold text-white ">
                      {user.activeSite?.principalInvestigatorName ||
                        localStorage.getItem('portal-active-site')}
                    </p>
                  </div>
                </div> */}
              {orders.kitsAccess === true && (
                <Nav.Link
                  onClick={() => {
                    setformName("Cart")
                    setFormIcon(<Sponsor />)
                    setCTA(() => {})
                    setCancelText("Cancel")
                    setConfirmText("Checkout")
                    setCanfirmIcon(<Sponsor />)
                    dispatch(setForm({ state: true, type: "show-cart" }))
                  }}
                  className="relative items-center justify-center p-0 rounded-full d-flex w-9 h-9 bg-whiteRGB"
                >
                  {addtoCart && (
                    <Lottie
                      animationData={animationData}
                      loop={true}
                      style={{
                        position: `absolute`,
                        height: 110,
                        width: 110,
                        left: -18,
                      }}
                    />
                  )}

                  <BuyIcon />
                  <div className="absolute top-[-2px] right-[-2px]">
                    <div className="flex items-center justify-center w-4 h-4 rounded-full bg-linearGradient2">
                      <span className=" font-medium m-0 text-xs leading-[14px] text-white">
                        {renderCartCount()}
                      </span>
                    </div>
                  </div>
                </Nav.Link>
              )}
                <NavDropdown
                  className="items-center justify-center p-0 m-0 d-flex user-dropdown "
                  title={
                    <div className="flex items-center ">
                      <div className="pr-1">
                        <ProfileIcon />
                      </div>
                      <p className="m-0 text-[15px] leading-[16px] font-semibold text-white capitalize ">
                        {localStorage.getItem("hema-token-first")}
                      </p>
                      <div className="pl-2">
                        <SelectDownArrow color="#ffffff" />
                      </div>
                    </div>
                  }
                  id="basic-nav-dropdown"
                >

                {orders.kitsAccess === true && (
                  <NavLink
                    className={({ isActive }) =>
                      isActive
                        ? "bg-[#F1F1F1] text-[#232323] w-full font-normal flex  no-underline"
                        : " text-subheadingColor font-normal  w-full flex no-underline hover:bg-[#F1F1F1] hover:text-[#232323] "
                    }
                    to="/orders"
                  >
                    <div className="w-auto flex items-center  gap-2 ">
                      <OrderHistory />
                      <span className="text-base font-semibold">
                        Order History For This Site
                      </span>
                    </div>
                  </NavLink>
                )}

                {orders.kitsAccess === true && (
                  <NavLink
                    className={({ isActive }) =>
                      isActive
                        ? "bg-[#F1F1F1] text-[#232323] w-full font-normal flex  no-underline"
                        : " text-subheadingColor font-normal  w-full flex no-underline hover:bg-[#F1F1F1] hover:text-[#232323] "
                    }
                    to="/address-book"
                  >
                    <div className="w-auto flex items-center  gap-2 ">
                      <AddressBook />
                      <span className="text-base font-semibold">
                        Address Book
                      </span>
                    </div>
                  </NavLink>
                )}

                {orders.kitsAccess === true && (
                  <NavLink
                    className={({ isActive }) =>
                      isActive
                        ? "bg-[#F1F1F1] text-[#232323] w-full font-normal flex  no-underline"
                        : " text-subheadingColor font-normal  w-full  flex  no-underline hover:bg-[#F1F1F1] hover:text-[#232323] "
                    }
                    to="/checkout"
                  >
                    <div className="w-auto flex items-center  gap-2 ">
                      <CheckoutMenu />
                      <span className="text-base font-semibold">Checkout</span>
                    </div>
                  </NavLink>
                )}
                  <NavDropdown.Item
                    className="user-down-item"
                    href=""
                    onClick={handleShow}
                  >
                    <div className="w-auto flex items-center  gap-2 ">
                      <Logout />
                      <span className="text-base font-semibold">Logout</span>
                    </div>
                  </NavDropdown.Item>
                </NavDropdown>
                <div
                  onClick={() => setOpenOrderM(!openOrderM)}
                  className="w-[36px] hidden lg:flex items-center justify-center flex-shrink-0 h-[36px] rounded-full bg-whiteRGB cursor-pointer"
                >
                  <HeaderDropdownColor />
                </div>
                {/* {openOrderM && ( */}
                <div
                  ref={popUpRef}
                  className={`z-10 top-[80px] right-[40px] lg:absolute ${
                    !openOrderM ? "w-full block lg:hidden" : "block"
                  }`}
                >
                  <div className="ordering-kits-box">
                    <h3 className="font-semibold text-[24px] leading-[34px] text-[#605DAF] mb-[17px] text-center">
                      You're Ordering Kits For
                    </h3>
                    <div className="w-full flex flex-col items-start gap-[12px] ">
                      <div className="w-full">
                        <div className="flex items-center gap-[2px] mb-[9px]">
                          <Sponsor />
                          <span className="text-[#232323] font-semibold text-[14px] leading-[16px] m-0 ">
                            Sponsor
                          </span>
                        </div>
                        <div className="w-full px-[16px] py-[10px] bg-white rounded-full flex items-center justify-between">
                          <input
                            type="text"
                            value={
                              user.activeSponser?.name ||
                              localStorage.getItem("portal-active-sponsor")
                            }
                            className="border-none outline-none font-[500] text-[14px] leading-[18px] text-[#605DAF]"
                          />
                          {user.userStatus?.studies.length > 1 && (
                            <div
                              className="cursor-pointer"
                              onClick={() => {
                                dispatch(
                                  setForm({
                                    state: true,
                                    type: "edit-user-status",
                                  })
                                )
                              }}
                            >
                              <Edit color="#605DAF" />
                            </div>
                          )}
                        </div>
                      </div>
                      {/* 2 */}
                      <div className="w-full">
                        <div className="flex items-center gap-[2px] mb-[9px]">
                          <Study color="#232323" />
                          <span className="text-[#232323] font-semibold text-[14px] leading-[16px] m-0 ">
                            Study
                          </span>
                        </div>
                        <div className="w-full px-[16px] py-[10px] bg-white rounded-full flex items-center justify-between">
                          <input
                            type="text"
                            value={
                              user.activeStudy?.name ||
                              localStorage.getItem("portal-active-study")
                            }
                            className="border-none outline-none font-[500] text-[14px] leading-[18px] text-[#605DAF]"
                          />
                          {user.userStatus?.studies.length > 1 && (
                            <div
                              className="cursor-pointer"
                              onClick={() => {
                                dispatch(
                                  setForm({
                                    state: true,
                                    type: "edit-user-status",
                                  })
                                )
                              }}
                            >
                              <Edit color="#605DAF" />
                            </div>
                          )}
                        </div>
                      </div>
                      {/* 3 */}
                      <div className="w-full">
                        <div className="flex items-center gap-[2px] mb-[9px]">
                          <Site color="#232323" />
                          <span className="text-[#232323] font-semibold text-[14px] leading-[16px] m-0 ">
                            Site
                          </span>
                        </div>
                        <div className="w-full px-[16px] py-[10px] bg-white rounded-full flex items-center justify-between">
                          <input
                            type="text"
                            value={
                              user.activeSite?.name ||
                              localStorage.getItem("portal-active-site")
                            }
                            className="border-none outline-none font-[500] text-[14px] leading-[18px] text-[#605DAF]"
                          />
                          {user.userStatus?.sites.length > 1 && (
                            <div
                              className="cursor-pointer"
                              onClick={() => {
                                dispatch(
                                  setForm({
                                    state: true,
                                    type: "edit-user-status",
                                  })
                                )
                              }}
                            >
                              <Edit color="#605DAF" />
                            </div>
                          )}
                        </div>
                      </div>
                      {/* 4 */}
                      <div className="w-full">
                        <div className="flex items-center gap-[2px] mb-[9px]">
                          <Sponsor />
                          <span className="text-[#232323] font-semibold text-[14px] leading-[16px] m-0 ">
                            PI
                          </span>
                        </div>
                        <div className="w-full px-[16px] py-[10px] bg-white rounded-full flex items-center justify-between">
                          <input
                            type="text"
                            value={
                              user.activeSite?.principalInvestigatorName ||
                              localStorage.getItem("portal-active-site")
                            }
                            className="border-none outline-none font-[500] text-[14px] leading-[18px] text-[#605DAF]"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* )} */}
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <div className="modal show modal-show">
        <Modal
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={show}
          onHide={handleClose}
          animation={false}
        >
          <Modal.Body>
            <p className="text-base font-semibold m-0 text-center">
              Are you sure you want to Logout?
            </p>
          </Modal.Body>

          <Modal.Footer>
            <div className="flex gap-[20px]  items-center justify-center w-full">
              <p
                className="user-down-item text-base font-semibold cursor-pointer m-0"
                href=""
                onClick={() => {
                  localStorage.removeItem("hema-token")
                  localStorage.removeItem("hema-token-refresh")
                  localStorage.removeItem("portal-active-site")
                  localStorage.removeItem("portal-active-study")
                  localStorage.removeItem("portal-active-sponsor")
                  localStorage.removeItem("portal-active-site-id")
                  window.location.reload()
                }}
              >
                Yes
              </p>
              <p className="user-down-item text-base font-semibold cursor-pointer m-0" href="" onClick={handleClose}>
                No
              </p>
            </div>
          </Modal.Footer>
        </Modal>
      </div>

      {uisettings?.openform && (
        <FormContainer
          cta={CTA}
          formType={updatedData}
          formName={formName}
          Icon={formIcon}
          formValidation={formValidation}
          setUpdatedData={setUpdatedData}
          setCTA={setCTA}
          cancelText={cancelText}
          CancelIcon={CancelIcon}
          confirmText={confirmText}
          CanfirmIcon={CanfirmIcon}
        />
      )}
    </div>
  )
}
export default HemaNavbar
